// extracted by mini-css-extract-plugin
export var compactFilters = "_bn-4";
export var detailImage = "_bn-1";
export var dropdownContainer = "_bn-2";
export var imageContainer = "_bn-0";
export var selectedCard = "_bn-3";